import ServicePage from "@/components/ServicePage";
export default function HairStudio() {
  return <ServicePage slug="hair" />;
}
